import { frjArticleUrlToCompassUrl } from "../../bits/frjUtils";

export type Source = {
  index: number;
  source: string;
  source_reference: string;
  heading: string;
  similarity: number;
  book_id?: string;
  fragment_id?: string;
  slug?: string;
  category?: string;
  url?: string;
  content?: string;
  purchase_url?: string;
  cover_url?: string;
};

export type StreamPhase =
  | "idle"
  | "searching"
  | "sources"
  | "thinking"
  | "streaming"
  | "complete";

export type SourceGroup = {
  key: string;
  label: string;
  coverUrl?: string;
  isBook: boolean;
  isOwned: boolean;
  purchaseUrl?: string;
  items: { source: Source; globalIndex: number }[];
};

export type UpsellPopoverState = {
  anchorEl: HTMLElement;
  bookTitle: string;
  purchaseUrl: string;
};

export const isBookSource = (s: Source) => "book_id" in s && s.book_id != null;

export const getSourceUrl = (
  s: Source,
  publicationsBySlug?: Record<string, unknown>,
) => {
  if (s.fragment_id) {
    const slug = s.fragment_id.split("-ch:")[0];
    if (publicationsBySlug?.[slug]) {
      return {
        url: `/pub/${slug}#${s.fragment_id}`,
        target: "_blank",
        rel: "noopener noreferrer",
      };
    }
    return { url: undefined }; // non-owned book — upsell handled by popover
  }
  if (!s.url) {
    return { url: undefined };
  }
  return {
    url: frjArticleUrlToCompassUrl(s.url),
    target: "_blank",
    rel: "noopener noreferrer",
  };
};

export const getSourceLabel = (s: Source) => {
  const parts = s.source.split(" > ");
  const name = parts[0];
  return name.replace(/^FRJ:\s*/, "");
};
